import { render, staticRenderFns } from "./sparePartDeliveryOrder.vue?vue&type=template&id=0bd987e0&scoped=true"
import script from "./sparePartDeliveryOrder.vue?vue&type=script&lang=js"
export * from "./sparePartDeliveryOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd987e0",
  null
  
)

export default component.exports